import { filterSimple_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import { multipleSelector_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import { pagination_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import { resultsInfo_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { filterAutocomplete_template } from "./filterAutocomplete_template";

declare var ko: any;

export class tagsImport_template extends vnTemplate {
    public datasetFilterAutocomplete: filterAutocomplete_template;
    protected tagImportfilter: filterSimple_template;
    protected pagination: pagination_template;
    protected resultInfos: resultsInfo_template;
    protected importStatusFilter: multipleSelector_template;
    protected priorityFilter: multipleSelector_template;

    protected FORM_DATASETNAME = 'FORM_DATASETNAME';

    protected getTemplateHtml(): string {

        return /*html*/ `
        <div class="sub-header tags_header w-justify">
            <div class="w-form-body">
                <div class="form-body">
                    <div class="form-group">
                    <div class="form-footer">
                         <button type="button" class="btn icon i-next" data-bind="event: { click: onClickCancel }">Back</button>
                    </div>
                        ${this.datasetFilterAutocomplete.getHtmlBuild()}
                        <div class="form-group">
                        <div class="tag_import-dropzone">
                           <label for="csvFile" class="form-label-tag icon i-upload">Choose File</label>
                           <input class="file-input" id="csvFile" type="file" accept=".csv" data-bind="event: { change: onFileSelected }">
                        </div>
                        <input type="checkbox" data-bind="checked: isImportOnlyMissingData" id="isImportOnlyMissingData">
                        <label class="icon i-check" for="isImportOnlyMissingData">Only Import Missing Data</label>
                        <div class="form-footer">
                           <button type="button" class="btn highlight icon i-check" data-bind="event: { click: onClickImportTags }, class:  csvFile() ? '' : 'is-disable'">Import</button>
                        </div>
                        <div class="w-form-body file-zone" id="tag-update-predictions">
                           <!-- ko if: tagUpdatePredictions().length > 0 -->
                            <div class="form-group">
                                 <div class="form-label">Tag updates for existing tag types</div>
                                 <div class="form-group file-name" data-bind="foreach: tagUpdatePredictions">
                            <!-- ko if: $data.isExistingTagTypeDataset -->
                                 <div class="file-name-tag" data-bind="text:$data.tagTypeName + ' (' + $data.datasetName + '): ' + $data.tagCount "></div>
                             <!-- /ko -->
                            </div>
                            <div class="form-label">Tag updates for new tag types</div>
                                <div class="form-group" data-bind="foreach: tagUpdatePredictions">
                                <!-- ko ifnot: $data.isExistingTagTypeDataset -->
                                <div class="file-name-tag" data-bind="text:$data.tagTypeName + ' (' + $data.datasetName + '): ' + $data.tagCount "></div>
                                <!-- /ko -->
                            </div>
                         </div>
                           <!-- /ko -->
                    </div>
                </div>
             </div>
           </div>
          </div>
        </div>

        <div class="list-header w-justify">
            <div class="w-left">
                <div class="sub-header">

                    <div>${ this.importStatusFilter.getHtmlBuild() }</div>
                    <div>${ this.priorityFilter.getHtmlBuild() }</div>
                </div>
            </div>
            <div class="w-center">${this.tagImportfilter.getHtmlBuild()}</div>
            <div id="pagination" class="w-pagination w-right" data-bind="template: { name: 'pagination-template', data: pagination }">
                <div class="pagination">
                    <input data-bind="value: pageNumber" type="hidden" value="1">
                    <span><a data-bind="event: { click: onClickPageFirst }" class="hidden prev">first</a></span>
                    <ul data-bind="foreach: pages">
                        <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page active">1</a></li>
                        <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page">2</a></li>
                        <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page">3</a></li>
                    </ul>
                    <span><a data-bind="event: { click: onClickPageLast }" class="hidden next">last</a></span>
                </div>
            </div>
        </div>

        <div class="w-list-results" id="list-results">
            <table class="list-results">
                ${this.resultInfos.getHtmlBuild()}
                <thead>
                    <tr>
                        <th><span class="icon" data-bind="event: { click: onClickReorder.bind($data, 'status') }, css: getSortingClassForColumn('status')">Status</span></th>
                        <th><span class="icon" data-bind="event: { click: onClickReorder.bind($data, 'name') }, css: getSortingClassForColumn('name')">Tag Name</span></th>
                        <th><span class="icon" data-bind="event: { click: onClickReorder.bind($data, 'tagTypeName') }, css: getSortingClassForColumn('tagTypeName')">Tag Type Name</span></th>
                        <th><span class="icon" data-bind="event: { click: onClickReorder.bind($data, 'datasetName') }, css: getSortingClassForColumn('datasetName')">Dataset</span></th>
                        <th><span class="icon" data-bind="event: { click: onClickReorder.bind($data, 'idTag') }, css: getSortingClassForColumn('idTag')">Tag ID</span></th>
                        <th><span class="icon" data-bind="event: { click: onClickReorder.bind($data, 'dateCreated') }, css: getSortingClassForColumn('dateCreated')">Date Uploaded</span></th>
                        <th><span class="icon" data-bind="event: { click: onClickReorder.bind($data, 'dateUpdated') }, css: getSortingClassForColumn('dateUpdated')">Date Updated</span></th>
                        <th><span class="icon" data-bind="event: { click: onClickReorder.bind($data, 'statusMessage') }, css: getSortingClassForColumn('statusMessage')">Status Message</span></th>
                        <th><span class="icon" data-bind="event: { click: onClickReorder.bind($data, 'priority') }, css: getSortingClassForColumn('priority')">Priority</span></th>
                    </tr>
                </thead>
                <tbody data-bind="foreach: imports">
                    <tr class="cursor" >
                        <td class="align-center"><span class="status" data-bind="class: 'status-' + status.replace(/[^a-z0-9]+/gi, '-').toLowerCase()"></span></td>
                        <td><span data-bind="text: name"></span></td>
                        <td><span data-bind="text: tagTypeName"></span></td>
                        <td><span data-bind="text: datasetName"></span></td>
                        <td><span data-bind="text: idTag"></span></td>
                        <td><span data-bind="text: dateCreated"></span></td>
                        <td><span data-bind="text: dateUpdated"></span></td>
                        <td><div data-bind="foreach: statusMessage">
                            <div data-bind="text: $data"></div>
                        </div></td>
                        <td><span data-bind="text: priority ? priority : '0'"></span></td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="list-header w-justify">
            <div id="pagination" class="w-pagination w-right" data-bind="template: { name: 'pagination-template', data: pagination }">
                <div class="pagination">
                    <input data-bind="value: pageNumber" type="hidden" value="1">
                    <span><a data-bind="event: { click: onClickPageFirst }" class="hidden prev">first</a></span>
                    <ul data-bind="foreach: pages">
                        <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page active">1</a></li>
                        <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page">2</a></li>
                        <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page">3</a></li>
                    </ul>
                    <span><a data-bind="event: { click: onClickPageLast }" class="hidden next">last</a></span>
                </div>
            </div>
        </div>
        `;
    }

    protected initPartial(): void {
        this.datasetFilterAutocomplete = new filterAutocomplete_template("datasetFilterAutocomplete", this.getTemplateViewModel(), this.caller);
        this.datasetFilterAutocomplete.setPlaceholderAndLabel("Tag Type Dataset");
        this.datasetFilterAutocomplete.setNumberOfChars(1);
        this.datasetFilterAutocomplete.setAddNewOptionEnabled(true);

        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;

        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller)

        this.tagImportfilter = new filterSimple_template("tagImportfilter", this.getTemplateViewModel(), this.caller);

        this.importStatusFilter = new multipleSelector_template("importStatusFilter", this.getTemplateViewModel(), this.caller);
        this.importStatusFilter.setLabel("status");
        this.importStatusFilter.setFilterContainerClass('margin-neg');
        this.importStatusFilter.setTagContainerId('selected-status');
        this.importStatusFilter.setTagContainerCaption('Status:');
        this.setStatusFilterItems([{id : 0, name: 'Pending'}, {id : 1, name: 'In Progress'}, {id : 2, name: 'Success'}, {id : 3, name: 'Requires More Info'}, {id : 4, name: 'Requires Review'}, {id : -1, name: 'Failed'}]);

        this.priorityFilter = new multipleSelector_template("priorityFilter", this.getTemplateViewModel(), this.caller);
        this.priorityFilter.setLabel("priority");
        this.priorityFilter.setFilterContainerClass('margin-neg');
        this.priorityFilter.setTagContainerId('selected-priority');
        this.priorityFilter.setTagContainerCaption('Priority:');
        this.priorityFilter.setItems([{id : 0, name: '0'}, {id : 1, name: '1'}, {id : 2, name: '2'}, {id : 3, name: '3+'}]);
    }

    protected getTemplateName(): string {

        return "tagsImport_template";
    }

    protected buildViewModel(): any {

        let vm = {
            idBrand: ko.observable(),
            csvFile: ko.observable(),
            selectedDataset: ko.observable(),
            datasetOptions: ko.observableArray([]),
            newDatasetName: ko.observable(""),
            imports: ko.observableArray([]),
            orderBy: ko.observable("dateUpdated"),
            orderByDirection: ko.observable("DESC"),
            orderByAndDirection: ko.observable("dateUpdated_DESC"),
            isImportOnlyMissingData: ko.observable(false),
            onClickCancel: this.onClickCancel.bind(this),
            onClickImportTags: this.onClickImportTags.bind(this),
            onClickReorder: this.onClickReorder.bind(this),
            onFileSelected: this.onFileSelected.bind(this),
            getSortingClassForColumn: this.getSortingClassForColumn.bind(this),
            tagTypeDatasetCounts: ko.observable({}),
            existingTagTypes: ko.observableArray([]),
            tagPredictionsIsLoading: ko.observable(false),
            tagUpdatePredictions: ko.pureComputed(() => {
                const tagTypeDatasetCounts = vm.tagTypeDatasetCounts();
                const selectedDatasetName = vm.selectedDataset() ? vm.selectedDataset().name : 'null'
                const existingTagTypes = vm.existingTagTypes();
                const datasetName = vm.newDatasetName() ? vm.newDatasetName() : selectedDatasetName

                const existingTagTypeDatasetPairs = existingTagTypes.map((tagType) => {
                    return `${tagType.name},${tagType.dataset ? tagType.dataset.name : 'null'}`
                })

                const tagUpdatePredictions = Object.keys(tagTypeDatasetCounts).map((tagTypeKey) => {
                    const tagType = tagTypeKey.split(",");
                    const currentTagTypeName = tagType[0]
                    const currentTagTypeDatasetName = tagType[1] ? tagType[1].replace(this.FORM_DATASETNAME, datasetName) : 'null'
                    const isExistingTagTypeDataset = existingTagTypeDatasetPairs.includes(`${currentTagTypeName},${currentTagTypeDatasetName}`);

                    return {
                        tagTypeName: currentTagTypeName,
                        datasetName: currentTagTypeDatasetName,
                        tagCount :tagTypeDatasetCounts[tagTypeKey],
                        isExistingTagTypeDataset: isExistingTagTypeDataset,
                    }
                });

                return tagUpdatePredictions;
            }, this),
        }

        vm.csvFile.subscribe(() => this.processCSVFile());
        vm.tagTypeDatasetCounts.subscribe(() => this.getTagTypeDatasetPairs());
        vm.selectedDataset.subscribe(() => this.getTagTypeDatasetPairs());

        return vm
    }
    public getViewModelForImportRequest() {
        let datasetName = "";

        if (this.datasetFilterAutocomplete.getTemplateViewModel().addNewSelected()) {
            datasetName = this.getTemplateViewModel().newDatasetName();
        } else if (this.getTemplateViewModel().selectedDataset()) {
            datasetName = this.getTemplateViewModel().selectedDataset().name;
        }

        return {
            idBrand: this.getTemplateViewModel().idBrand(),
            datasetName: datasetName,
            csvFile: this.getTemplateViewModel().csvFile(),
            isImportOnlyMissingData: this.getTemplateViewModel().isImportOnlyMissingData(),
        }
    }

    public getViewModelForImportEntriesRequest() {

        return {
            pagination: this.getTemplateViewModel().pagination,
            orderBy: this.getTemplateViewModel().orderBy,
            orderByDirection: this.getTemplateViewModel().orderByDirection,
            orderByAndDirection: this.getTemplateViewModel().orderByAndDirection,
            filters: {
                keyword: this.getTemplateViewModel().tagImportfilter.filterKeyword,
                status: this.getTemplateViewModel().importStatusFilter.selectedItems(),
                priority: this.getTemplateViewModel().priorityFilter.selectedItems(),
            },
        }
    }

    public getViewModelForTagTypeDatasetPairsRequest() {
        const replace = /FORM_DATASETNAME/g
        const datasetName = this.getTemplateViewModel().selectedDataset() ? this.getTemplateViewModel().selectedDataset().name : 'null'
        return {
            pairs: Object.keys(this.getTagTypeDatasetCounts()).map((tagType) => tagType.replace(replace, datasetName).split(',')),
        }
    }

    private onFileSelected(data, event) {
        var file = event.target.files[0];
        if (file) {
            this.getTemplateViewModel().csvFile(file);
        }
    }

    public clearFileSelection() {
        let inputCSV: HTMLInputElement | null = document.querySelector('input#csvFile');
        if (inputCSV) {
            inputCSV.value = '';
            this.getTemplateViewModel().csvFile(null);
        }
    }

    private onClickImportTags(data, event) {
        this.caller.importTags();
    }

    private onClickCancel() {
        this.caller.cancel();
    }

    public set_idBrand(idBrand): void {

        this.getTemplateViewModel().idBrand(idBrand);
    }

    public setDatasetOptions(options) {
        this.datasetFilterAutocomplete.setOptions(options);
    }

    public setNewDatasetName(newDatasetName) {
        this.getTemplateViewModel().newDatasetName(newDatasetName);
    }

    public updateList(imports, nbResults, nbPages, execTime) {
        this.setImports(imports);
        this.pagination.setNumberItemToPaginate(nbResults);
        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    private setImports(imports) {
        this.getTemplateViewModel().imports(imports);
    }

    private onClickReorder(value, data, event) {

        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.getTagImportEntries();
    }

    private getSortingClassForColumn(column) {
        return column == this.getTemplateViewModel().orderBy() ? "list-sort-" + this.getTemplateViewModel().orderByDirection().toLowerCase() : "list-sort-none";
    }

    public setExistingTagTypes(tagTypes) {
        this.getTemplateViewModel().existingTagTypes(tagTypes);
    }

    public getTagTypeDatasetCounts() {
        return this.getTemplateViewModel().tagTypeDatasetCounts();
    }

    public setTagPredictionsIsLoading(islaoding) {
        this.getTemplateViewModel().tagPredictionsIsLoading(islaoding);
    }

    private getTagTypeDatasetPairs() {
        if(this.getTemplateViewModel().csvFile()) {
            this.caller.getTagTypeDatasetPairs();
        }
    }

    public setStatusFilterItems(statuses): void {
        for(let status of statuses) {
            if(typeof status.name == "string") {
                const iconClass = `status-${status.name.replace(/[^a-z0-9]+/gi, '-').toLowerCase()}`;
                status.itemIcon = `<i class="icon i-${iconClass}"></i>`;
            }
        }

        this.importStatusFilter.setItems(statuses);
    }

    private processCSVFile() {
        const file = this.getTemplateViewModel().csvFile();
        const tagTypeDatasetPairs = {};

        const reader = new FileReader();


        reader.addEventListener('load', () => {
            const text = String(reader.result);
            const lines = text.split('\n');
            const lineArray = []
            // Select commas that are not inside double quotes
            const regex = /,(?=(?:(?:[^"]*"){2})*[^"]*$)/g
            lines.map((line) => {
                lineArray.push(line.split(regex));
            });

            // Extract header and subheader
            const header = lineArray[0];
            const subHeader = lineArray[1];
            const tagFieldRows = []
            // Find index of rows with "Tag" and "Tags"
            for (var i = 0; i < header.length; i++) {
                if (header[i] == 'Tag') {
                    tagFieldRows.push(i)
                }
                else if (header[i] == 'Tags') {
                    tagFieldRows.push(i)
                }
            }
            // Find index of Tag Type Name
            const tagTypeNameIndex = subHeader.indexOf('Tag Type Name');

            lineArray.slice(2).forEach((line) => {
                const tagTypeKey = `${line[tagTypeNameIndex]},${this.FORM_DATASETNAME}`;
                if (line[tagTypeNameIndex] && tagTypeKey != '') {
                    tagTypeDatasetPairs[tagTypeKey] ? tagTypeDatasetPairs[tagTypeKey] += 1 : tagTypeDatasetPairs[tagTypeKey] = 1
                }

                let tagList = []
                tagFieldRows.forEach((tagRow) => {
                    try {
                        tagList = [
                            ...tagList,
                            ...JSON.parse(line[tagRow].replace(/""/g, "'").replace(/"/g, '').replace(/'/g, '"'))
                        ];
                    } catch (error) {
                        console.log('error parsing tag list');
                    }

                })

                tagList.forEach((tag) => {
                    const key = `${tag.type},${('datasetName' in tag) ? tag.datasetName : this.FORM_DATASETNAME}`;
                    if (tag.type && key != '') {
                        tagTypeDatasetPairs[key] ? tagTypeDatasetPairs[key] += 1 : tagTypeDatasetPairs[key] = 1
                    }
                })
            });
            this.getTemplateViewModel().tagTypeDatasetCounts(tagTypeDatasetPairs);
        });

        // if the file is not empty, readAsText which sends a 'load' event
        if (file) {
            reader.readAsText(file);
        }
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/tagsImport_template.ts